import { AppBar, Box, Container, Toolbar, Typography } from "@mui/material";

export function HomeFooter() {
  return (
    <AppBar position="static">
      <Container
        style={{
          height: "130px", // Set the height to 150% of its default size
        }}
      >
        <Toolbar
          style={{
            display: "flex",
            flexFlow: "row",
            justifyContent: "space-between",
            alignItems: "flex-start", // Align the content to the top
          }}
        >
          <Box
            style={{
              display: "flex",
              flexFlow: "column",
              alignItems: "flex-start", // Align the content to the top
              marginTop: "20px",
            }}
          >
            <Typography style={{ fontSize: "0.8rem" }}>
              Dinas Perumahan Rakyat dan Kawasan Permukiman Kabupaten Ngawi,
              Provinsi Jawa Timur
            </Typography>
            <div style={{ marginTop: "10px" }}>
              <Typography style={{ fontSize: "0.8rem" }}>
                Jl. Raya Ngawi - Cepu KM. 3 Ngawi Purba, Ngawi Kode Pos : 63218
              </Typography>
              <Typography style={{ fontSize: "0.8rem" }}>
                Telp. (0351) 749005 - 749124
              </Typography>
              <Typography style={{ fontSize: "0.8rem" }}>
                Email : perkim@ngawikab.go.id
              </Typography>
            </div>
          </Box>
          <Box
            style={{
              display: "flex",
              flexFlow: "column",
              marginTop: "20px",
            }}
          >
            <Typography style={{ fontSize: "0.8rem" }}>
              Instalasi Pengolahan Lumpur Tinja Kabupaten Ngawi
            </Typography>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
